module.exports = __webpack_public_path__ + "img/5fbee46b-fa5e-4008-b5a2-17f2e2bc7119.2b42cd62.jpg";